import { render, staticRenderFns } from "./SubResourcesTable.vue?vue&type=template&id=440ae1f4&scoped=true&lang=pug&"
import script from "./SubResourcesTable.vue?vue&type=script&lang=js&"
export * from "./SubResourcesTable.vue?vue&type=script&lang=js&"
import style0 from "./SubResourcesTable.vue?vue&type=style&index=0&id=440ae1f4&lang=stylus&scoped=true&"
import style1 from "./SubResourcesTable.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440ae1f4",
  null
  
)

export default component.exports